import loadable from '@loadable/component';
import usePostHook from '../../customHooks/usePostHook';
import APIS from '../../constant/EndPoint';
import CreateIcon from '../../Icons/Create';
import { toast } from 'react-toastify';
import { getKey } from '../../helpers/sessionKey';
import { useNavigate } from 'react-router';
import useGetHook from '../../customHooks/useGetHook';
import { useSearchParams } from 'react-router-dom';
const CreateInvoiceComponent = loadable(
  () => import("../../components/Finance/CreateInvoice")
);
const CreateInvoice = () => {
  const [searchParams, setSearchParms] = useSearchParams()

  const navigate = useNavigate()
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["invoices"],
    navigateURL: "",
  });

  const { data: userProfileType } = useGetHook({
    queryKey: [`user-profile`],
    url: `${APIS.USER_PROFILE}`,
    params: {},
  });

  const handleCreate = async (values: any) => {

    const selectedOrder = searchParams.get("selectedItems")?.split(",")
    if (!selectedOrder?.length) {
      toast.error("Please select at least one order")
      return
    }
    const url = `${APIS.INVOICE}`;
    let formData = {
      order_ids: selectedOrder,
      ...values,
    };
    try {
      const res = await mutateAsync({ url, formData });
      if (res.status === 201) {
        navigate("/invoice")
      }
    } catch (err) {
      console.log(err);
    }
  };


  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">
          Create Invoice
        </span>
      </div>
      {userProfileType?.is_rider ? "Risder Invoixe" :
        <CreateInvoiceComponent
          handleCreate={handleCreate}
          isPostLoading={isPostLoading}
        />
      }
    </>
  )
}

export default CreateInvoice
